import React from "react";
import moment from "moment";
import "./RequestCard.css";

const statusColorMap = {
  "Completed": "rp-status-approved",
  "Form requested": "rp-status-requested",
  "Form submitted": "rp-status-requested",
  "Form resubmitted": "rp-status-resubmitted",
  "Send back by requestor": "rp-status-sendback",
  "Reopen": "rp-status-sendback",
  "Validated by requestor": "rp-status-resubmitted",
  "Cancelled": "rp-status-rejected",
  "Rejected by line manager": "rp-status-rejected",
  "Rejected by finance": "rp-status-rejected",
  "Approved by line manager": "rp-status-approved",
  "Approved by finance": "rp-status-approved",
};

export const getStatusBadge = (status) => {
  if (!status) return null;
  const cls = statusColorMap[status] || "rp-status-default";
  return <span className={`rp-status ${cls}`}>{status}</span>;
};

export const getEmployeeName = (account) =>
  (account.employee
    ? `${account.employee.firstName || ""} ${account.employee.lastName || ""}`.trim()
    : account.requestContactName) || "-";

// Lets Ctrl/Cmd/middle click fall through to the browser so the request opens in a new tab.
export const handleNavClick = (e, onClick) => {
  if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
    onClick && onClick(e);
  }
};

const RequestCard = ({ account, href, onClick }) => (
  <a className="hy-card" href={href} onClick={(e) => handleNavClick(e, onClick)}>
    <div className="hy-card__header">
      <span className="hy-card__id">{account.id}</span>
      <div>{getStatusBadge(account.status)}</div>
    </div>
    <div className="hy-card__body">
      <div className="hy-card__row">
        <span className="hy-card__label">Employee</span>
        <span className="hy-card__value">{getEmployeeName(account)}</span>
      </div>
      <div className="hy-card__row">
        <span className="hy-card__label">Email</span>
        <span className="hy-card__value">{account.requestContactEmail || "-"}</span>
      </div>
      <div className="hy-card__row">
        <span className="hy-card__label">Finance Approver</span>
        <span className="hy-card__value">{account.financeApproverToNotify || "-"}</span>
      </div>
      {account.formSubmittedDate && (
        <div className="hy-card__row">
          <span className="hy-card__label">Submitted</span>
          <span className="hy-card__value">{moment(account.formSubmittedDate).format("DD-MM-YYYY HH:mm")}</span>
        </div>
      )}
    </div>
  </a>
);

export default RequestCard;
